import { A } from "@solidjs/router";
import { Dynamic } from "solid-js/web";
import { Show } from "solid-js";
import { ArrowUpRightIcon } from "lucide-solid";
import { useLocale } from "@/context/locale";
import { DICT, dictVersion } from "@/context/locale";
import { LESSON_ICONS } from "./shared";

// Highlighted card for a country article: country name, divider and the
// article's subtitle question. Reads the lesson dict directly so it accepts
// a light lesson meta object ({ id, icon }) without the full lesson blocks.
export default function CountryCard(props) {
  const { t, locale } = useLocale();
  const node = () => {
    dictVersion();
    return DICT[locale]?.toolkit?.venus?.lessons?.[props.lesson.id];
  };
  const articleTitle = () => node()?.title ?? props.lesson.title ?? "";
  const articleSubtitle = () => (props.lesson.subtitle ? node()?.subtitle ?? props.lesson.subtitle : "");
  const description = () => articleSubtitle() || articleTitle();

  return (
    <A
      href={props.href}
      class="group flex flex-col gap-3 border border-border bg-surface/30 p-5 hover:bg-accent/40 transition-colors"
    >
      <span class="flex items-center justify-between gap-3">
        <span class="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
          {t("resources.country")}
        </span>
        <Show when={LESSON_ICONS[props.lesson.icon]}>
          {(Icon) => (
            <Dynamic component={Icon()} size={16} class="text-muted-foreground group-hover:text-foreground transition-colors" />
          )}
        </Show>
      </span>
      <h3 class="text-xl font-bold tracking-tight text-foreground">
        {t(`toolkit.venus.countryNames.${props.lesson.id}`)}
      </h3>
      <span class="h-px bg-gradient-to-r from-purple/60 to-transparent" aria-hidden="true" />
      <p class="text-sm text-muted-foreground leading-relaxed line-clamp-3">{description()}</p>
      <span class="mt-auto pt-2 text-xs font-semibold uppercase tracking-widest text-foreground inline-flex items-center gap-1">
        {t("awesome.featured.open")}
        <ArrowUpRightIcon size={12} class="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </A>
  );
}
